import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import { useSiteTheme } from '../theme/ThemeContext';



function AppLayout() {
  const { palette } = useSiteTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      <NavBar />

      <Box component="main" sx={{ flexGrow: 1, pt: 8, bgcolor: palette.navbar, }}>
        <Outlet />
      </Box>

      <Footer />
    </Box>
  );
}

export default AppLayout;